<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  stroke="none"
  class="w-5 h-5 fill-current">
  <path [attr.d]="iconPath" />
</svg>
